import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { uploadDocumentsInBrio } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

import type { UploadDocumentVariablesBrio } from '../types';

export default function useUploadDocumentBrio() {
  const { i18n } = useTranslation();

  const language = i18n.language === 'fr' ? 'FR' : 'NL';

  return useMutation({
    mutationFn: ({
      crmPartyId,
      filename,
      link,
      description,
    }: UploadDocumentVariablesBrio) =>
      uploadDocumentsInBrio(
        {
          params: {
            path: { brio_party_id: crmPartyId },
            query: {},
          },
          body: {
            name: filename,
            link,
            description,
            language,
          },
        },
        wgApi,
      ),
  });
}
